import { RaffleShortInfoResponse } from "../../types/api";

export interface RaffleData {
  id: number;
  background: string;
  date_end: string;
  date_start: string;
  status: string;
  short_prizes: Array<{
    type: string;
    amount: number;
    item_type?: string;
  }>;
}

export interface RaffleCategories {
  activeRaffles: RaffleData[];
  archivedRaffles: RaffleData[];
}

export class RaffleAdapter {
  static adaptRaffles(data: RaffleShortInfoResponse[]): RaffleCategories {
    const activeRaffles: RaffleData[] = [];
    const archivedRaffles: RaffleData[] = [];

    data.forEach((raffle) => {
      const raffleData: RaffleData = {
        id: raffle.id,
        background: raffle.background,
        date_end: raffle.end_date,
        date_start: raffle.start_date,
        status: raffle.status,
        short_prizes: raffle.main_prizes.map((prize) => ({
          type: prize.type,
          amount: prize.amount,
          item_type: prize.item_type,
        })),
      };

      if (raffle.status === "active" || raffle.status === "winner_selection") {
        activeRaffles.push(raffleData);
      } else if (raffle.status === "finish") {
        archivedRaffles.push(raffleData);
      }
    });

    return {
      activeRaffles,
      archivedRaffles,
    };
  }
}
